/*
 * Copyright (c) 2017, Indigen Solutions. All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This software is the confidential and proprietary information.
 *
 * You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement
 * you entered into.
 */
import * as moment from "moment";
import idLocale from "moment/locale/fr";
import { User } from "src/models/User.model";

import { ProductName, ProductVariantName } from "../types/Products";
import { ProductAAHelper } from "./ProductAA.helper";
import { ProductGOHelper } from "./ProductGO.helper";
import { ProductGPIHelper } from "./ProductGPI.helper";
import { ProductSPRHelper } from "./ProductSPR.helper";
moment.locale("fr", idLocale);

export function getProductHelper(
    name: string,
    variant: string
): ProductAAHelper | ProductSPRHelper | ProductGOHelper | ProductGPIHelper {
    switch (name) {
        case "AA":
            return new ProductAAHelper(variant);
        case "SPR":
            return new ProductSPRHelper(variant);
        case "GO":
            return new ProductGOHelper(variant);
        case "GPI":
            return new ProductGPIHelper(variant);
        default:
            return null;
    }
}

export function getProductDico(name: string, variant: string) {
    const helper = getProductHelper(name, variant);
    return helper.getDico();
}

export function getProductTitle(name: string, variant: string) {
    const dico = getProductDico(name, variant);
    return dico.cover.title;
}

export function getProductUrl(name: string, variant: string) {
    switch (name) {
        case "AA":
            return "/product/AA";
        case "SPR":
            return "/product/SPR";
        case "GO":
            if (variant === "PCO") {
                return "/product/GO/PCO";
            } else {
                return "/product/GO/PVO";
            }
        case "GPI":
            return "/product/GPI";
        default:
            return "/";
    }
}

export function getAvailableProductsForMe(user: User): { name: ProductName; variant?: ProductVariantName }[] {
    if (user.company.name === "mutuelledepoitiers") {
        return [{ name: "GO", variant: "PCO" }, { name: "GO", variant: "PVO" }];
    }

    switch (user.team) {
        case "VAD MDP":
            return [{ name: "AA" }, { name: "GO", variant: "PCO" }, { name: "GO", variant: "PVO" }];
        case "VS":
            return [{ name: "AA" }, { name: "GPI" }, { name: "GO", variant: "PCO" }, { name: "GO", variant: "PVO" }];
        case "MDPRO":
        case "VAD MDPRO":
            return [{ name: "AA" }];
        case "MDP":
        default:
            return [{ name: "AA" }, { name: "GPI" }, { name: "GO", variant: "PCO" }, { name: "GO", variant: "PVO" }];
    }
}

export function getDate(date: string, format: "small" | "big" = "small") {
    switch (format) {
        case "small":
            return moment(date).format("DD/MM/YYYY");
        case "big":
            return moment(date).format("LLL");
        default:
    }
    return "";
}

export function getTitle(title) {
    switch (title) {
        case "mr":
            return "Monsieur";
        case "miss":
        case "mrs":
            return "Madame";
        default:
            return "";
    }
}



// WEBPACK FOOTER //
// ./src/helper/functions.helper.ts